import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';

const ROLE_LABELS = {
  admin: 'Administrateur', conducteur: 'Conducteur de travaux',
  chef_chantier: 'Chef de chantier', sous_traitant: 'Sous-traitant', direction: 'Direction'
};

export default function Layout({ page, setPage, children }) {
  const { user, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  const nav = [
    { id: 'dashboard', icon: '📊', label: 'Tableau de bord' },
    { id: 'saisie',    icon: '✏️', label: 'Saisie avancement', roles: ['admin','conducteur','chef_chantier'] },
    { id: 'go',        icon: '🏗️', label: 'Gros œuvre + Étanch.' },
    { id: 'fluides',   icon: '💧', label: 'Fluides' },
    { id: 'elec',      icon: '⚡', label: 'Électricité' },
    { id: 'secondaire',icon: '🔨', label: 'Lot Secondaire' },
    { id: 'exterieurs',icon: '🌿', label: 'Extérieurs' },
    { id: 'problemes', icon: '⚠️', label: 'Obstacles' },
    { id: 'planning',  icon: '📅', label: 'Planning', roles: ['admin','conducteur','chef_chantier'] },
    { id: 'users',     icon: '👥', label: 'Utilisateurs', roles: ['admin'] },
  ].filter(n => !n.roles || n.roles.includes(user?.role));

  return (
    <div className="app-container">
      {/* Sidebar overlay for mobile */}
      <div className={`sidebar-overlay ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(false)}></div>

      {/* Sidebar */}
      <aside className={`sidebar ${menuOpen ? 'open' : ''}`} style={styles.sidebar}>
        <div style={styles.sidebarHeader}>
          <span style={styles.sidebarLogo}>🏗️</span>
          <div>
            <div style={styles.sidebarTitle}>Palmeraie</div>
            <div style={styles.sidebarSub}>Gestion Chantier</div>
          </div>
        </div>
        <nav style={styles.nav}>
          {nav.map(n => (
            <button key={n.id} style={{ ...styles.navBtn, ...(page === n.id ? styles.navBtnActive : {}) }}
              onClick={() => { setPage(n.id); setMenuOpen(false); }}>
              <span style={{ fontSize: 16 }}>{n.icon}</span>
              <span>{n.label}</span>
            </button>
          ))}
        </nav>
        <div style={styles.sidebarFooter}>
          <div style={styles.userInfo}>
            <div style={styles.userName}>{user?.prenom} {user?.nom}</div>
            <div style={styles.userRole}>{ROLE_LABELS[user?.role]}</div>
          </div>
          <button onClick={logout} style={styles.logoutBtn} title="Déconnexion">⏻</button>
        </div>
      </aside>

      {/* Main */}
      <main className="main-content" style={styles.main}>
        <div style={styles.topbar}>
          <button className="topbar-menu-btn" onClick={() => setMenuOpen(m => !m)}>☰</button>
          <h1 style={styles.pageTitle}>
            {nav.find(n => n.id === page)?.icon} {nav.find(n => n.id === page)?.label}
          </h1>
          <div style={styles.dateBadge}>{new Date().toLocaleDateString('fr-FR', { day:'numeric', month:'long', year:'numeric' })}</div>
        </div>
        <div style={styles.content}>{children}</div>
      </main>
    </div>
  );
}

const styles = {
  sidebar: { background:'#1a1a18', display:'flex', flexDirection:'column' },
  sidebarHeader: { display:'flex', alignItems:'center', gap:10, padding:'1.25rem 1rem', borderBottom:'1px solid #333' },
  sidebarLogo: { fontSize:24 },
  sidebarTitle: { color:'#fff', fontWeight:600, fontSize:14 },
  sidebarSub: { color:'#888', fontSize:11 },
  nav: { flex:1, padding:'0.75rem 0.5rem', display:'flex', flexDirection:'column', gap:2 },
  navBtn: { display:'flex', alignItems:'center', gap:10, padding:'9px 12px', background:'none', border:'none', color:'#aaa', cursor:'pointer', borderRadius:8, fontSize:13, fontWeight:500, textAlign:'left', width:'100%', transition:'all .12s' },
  navBtnActive: { background:'#2d2d2b', color:'#fff' },
  sidebarFooter: { padding:'1rem', borderTop:'1px solid #333', display:'flex', alignItems:'center', gap:8 },
  userInfo: { flex:1, minWidth:0 },
  userName: { color:'#fff', fontSize:13, fontWeight:500, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' },
  userRole: { color:'#888', fontSize:11 },
  logoutBtn: { background:'none', border:'none', color:'#888', fontSize:18, cursor:'pointer', padding:4 },
  main: { display:'flex', flexDirection:'column' },
  topbar: { background:'#fff', borderBottom:'1px solid #e0dfd8', padding:'0.75rem 1.5rem', display:'flex', alignItems:'center', gap:12, position:'sticky', top:0, zIndex:50 },
  pageTitle: { flex:1, fontSize:16, fontWeight:600, color:'#1a1a18' },
  dateBadge: { fontSize:12, color:'#6b6b67', background:'#f4f3ee', padding:'4px 10px', borderRadius:20 },
  content: { padding:'1.5rem', flex:1 },
};
